import React from "react"
import { useLabels } from "../../../../../features/contents/hooks"
import Typography from "../../../../../ui/atoms/Typography"
import { useAlgoliaSearchState } from "../../controller/state"

export const NoResults = () => {
  const { getLabel } = useLabels()
  const { searchResults } = useAlgoliaSearchState()

  if (!searchResults) {
    return <></>
  }

  const hasResults = searchResults.nbHits > 0
  if (!hasResults) {
    return (
      <div className="mt-6 mb-8">
        <Typography>{getLabel("search", "no-results")}</Typography>
      </div>
    )
  }
  return <></>
}
